import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
// import { clearToken, getToken } from "utils/auth-token-utils";
import {
  API,
  ENDPOINTS,
  MEDIA_SERVER_BASE_URL,
  SP_BASE_BODY,
  SP_NAMES,
} from "./constants";
import { IReq, IRes } from "./types";
import { STORAGE_KEYS, notify, storage } from "utils";

axios.defaults.headers.post["Content-Type"] = "application/json";

const apiInstance = axios.create({
  baseURL: API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const cdnApiInstance = axios.create({
  baseURL: MEDIA_SERVER_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

export const spApiInstance = <T>(
  spName: SP_NAMES,
  parameters: IReq = {},
  options?: {
    config?: AxiosRequestConfig<any>;
    disablePopup?: boolean;
  }
): Promise<T> => {
  return apiInstance
    .post<IRes<T>>(
      ENDPOINTS.SP,
      SP_BASE_BODY(spName, parameters),
      options?.config
    )
    .then((response) => response.data)
    .then(
      (response) => {
        if (response.successful) {
          if (!response.result) {
            options?.disablePopup ||
              notify({
                type: "success",
                message: response.resultMessage,
              });
          }

          return Promise.resolve(response.result);
        }
        options?.disablePopup ||
          notify({
            type: "error",
            message: response.resultMessage,
          });
        throw response.resultMessage;
      },
      (error) => {
        const errorBody = error?.response?.data;
        options?.disablePopup ||
          notify({
            type: "error",
            message: errorBody,
          });
        // as ErrorMessage;
        // return Promise.reject(errorTranslator(errorBody));
        throw errorBody;
      }
    )
    .catch((error) => {
      throw error;
    });
};

const responseSuccessHandler = (response: AxiosResponse<any, any>) => {
  return response;
};

const responseErrorHandler = (error: any) => {
  if (error?.response?.status === 401) {
    // NavHandler.reset([{name: ScreenNames.SignIn}]);
    // clearToken();
  }

  // return Error object with Promise
  return Promise.reject(error);
};

apiInstance.interceptors.request.use(
  async (config) => {
    if (config.data?.parameters) {
      config.data.parameters = {
        ...config.data.parameters,
        // Language: document.dir === "ltr" ? "EN" : "FA",
      };
    }
    if (config.headers) {
      const token = storage.read<string>(STORAGE_KEYS.TOKEN);
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiInstance.interceptors.response.use(
  (response) => {
    return responseSuccessHandler(response);
  },
  (error) => {
    return responseErrorHandler(error);
  }
);

export { apiInstance, cdnApiInstance };
